import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AgEditorComponent } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

@Component({
  selector: 'ml-numeric-cell-editor',
  templateUrl: './numeric-cell-editor.component.html',
  styleUrls: ['./numeric-cell-editor.component.scss'],
  standalone: true,
  imports: [FormsModule],
})
export class NumericCellEditorComponent implements AgEditorComponent {
  public value: number;

  public getValue() {
    return this.value;
  }

  public agInit(params: ICellEditorParams) {
    this.value = params.value;
  }
}
